import { render } from "./SavedCollectionsBackToSearch.vue?vue&type=template&id=0bebd2bc"
import script from "./SavedCollectionsBackToSearch.vue?vue&type=script&lang=js"
export * from "./SavedCollectionsBackToSearch.vue?vue&type=script&lang=js"

import "./SavedCollectionsBackToSearch.vue?vue&type=style&index=0&id=0bebd2bc&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
